const copyToClipboard = function(str) {
    const el = document.createElement('textarea');
    el.value = str;
    el.setAttribute('readonly', '');
    el.style.position = 'absolute';
    el.style.left = '-9999px';
    document.body.appendChild(el);
    el.select();
    document.execCommand('copy');
    document.body.removeChild(el);
};

$(document).ready( function() {
    $('.promocode').on('click', function() {
        copyToClipboard($(this).data('code'));
        $(this).find('.promocode__text').text($(this).data('copied') || 'Copied!');
        $(this).addClass('promocode--copied');
    })
});
